<template>
    <v-container>
      <vue-aos animation-class="animate__zoomInLeft animate__animated">
        <v-row justify="center" align="center" style="height: 80vh;">
          <v-col cols="12" md="6" lg="4">
            <v-card elevation="10" class="pa-10 rounded-lg" color="rgba(255, 255, 255, 0.9)">
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col class="text-center">
                    <img src="/img/siglasigfoco.svg" alt="brasão-home-64px" />
                    <h1 class="subtitle-1 blue--text text--darken-4 mt-4 font-weight-bold">
                      Definir Nova Senha
                    </h1>
                  </v-col>
                </v-row>
  
                <v-row class="mb-4">
                  <v-col>
                    <v-text-field
                      v-model="user.senhaAtual"
                      solo
                      placeholder="Senha Atual*"
                      type="password"
                      maxlength="256"
                      :rules="senhaRules()"
                      outlined
                      dense
                      class="rounded-lg"
                      prepend-inner-icon="mdi-account"
                    ></v-text-field>
                  </v-col>
                </v-row>
  
                <v-row class="mb-4">
                  <v-col>
                    <v-text-field
                      v-model="user.novaSenha"
                      solo
                      placeholder="Nova Senha*"
                      type="password"
                      maxlength="256"
                      :rules="novaSenhaRules()"
                      outlined
                      dense
                      class="rounded-lg"
                      prepend-inner-icon="mdi-lock"
                    ></v-text-field>
                  </v-col>
                </v-row>
  
                <v-row class="mb-4">
                  <v-col>
                    <v-text-field
                      v-model="user.confirmarSenha"
                      solo
                      placeholder="Confirmar a Nova Senha*"
                      type="password"
                      maxlength="256"
                      :rules="confirmarSenhaRules()"
                      outlined
                      dense
                      class="rounded-lg"
                      prepend-inner-icon="mdi-lock"
                    ></v-text-field>
                  </v-col>
                </v-row>
  
                <v-row class="d-flex justify-center">
                  <v-btn
                    color="success"
                    :loading="loading"
                    @click="recuperarSenha()"
                    class="py-4 px-6 mr-3 rounded-lg"
                  >
                    Salvar
                  </v-btn>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </vue-aos>
    </v-container>
  </template>
  
  <script>
//   import configurations from "commons/configurations";
  import VueAos from "vue-aos";
  import PageLoadingMixin from "~/mixins/page-loading.mixin";
  import UsuarioService from '~/services/manter-usuario.service';
  import { LOGIN} from 'store/modules/auth';
  export default {
    name: "TrocarSenha",
    mixins: [PageLoadingMixin, UsuarioService],
    components: { VueAos },
    data: () => ({
      user: {
        senhaAtual: undefined,
        novaSenha: undefined,
        confirmarSenha: undefined,
      },
      valid: false,
      loading: false,
    }),
    methods: {
        senhaRules() {
            return [
                (v) => !!v || "Campo obrigatório",
                (v) => (v && v.length >= 8) || "A senha deve conter pelo menos 8 caracteres.",
            ];
        },
        novaSenhaRules() {
            return [
                (v) => !!v || "Campo obrigatório",
                (v) => (v && v.length >= 8) || "A senha deve conter pelo menos 8 caracteres.",
            ];
        },

        confirmarSenhaRules() {
            return [
                (v) => !!v || "Campo obrigatório",
                (v) => (v && v.length >= 8) || "Confirmar a Nova Senha deve conter pelo menos 8 caracteres.",
                (v) => v === this.user.novaSenha || "As senhas informadas não correspondem.",
            ];
        },
      refreshTokenUi() {
        this.$renovarToken().then(({ data }) => {
          if (data.sucesso) {
            this[LOGIN](data);
            this.$router.push("/app");
          }
        });
      },
      recuperarSenha() {
        const save = () => {
            return this.$swal({
            text: `Deseja confirmar essa operação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
            }).then(() => {
            return this.$trocarSenha(this.user);
            });
        };

        if (this.$validarFormulario()) {
            save().then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.$emit("onClose");
            this.$emit("onSave");
            this.refreshTokenUi();
            });
        }
    }
    },
  };
  </script>
  
  <style scoped>
  .page--login {
    background: linear-gradient(135deg, #1976D2, #2196F3);
    border-radius: 12px;
    padding: 20px;
  }
  .form-container {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
  }
  .v-btn:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease-in-out;
  }
  </style>
  